/* unplugin-vue-components disabled */import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "line-echart"
};
import BaseEchart from '@/base-ui/echart';
export default /*#__PURE__*/_defineComponent({
  __name: 'line-echart',
  props: {
    lineData: {},
    xLabels: {},
    legendData: {
      default: function _default() {
        return [];
      }
    },
    yName: {
      default: ''
    },
    height: {
      default: '250px'
    },
    grid: {
      default: function _default() {
        return {
          left: '5%',
          right: '4%',
          bottom: '3%',
          top: '60',
          containLabel: true
        };
      }
    },
    type: {
      default: 'category'
    },
    tooltip: {
      default: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross',
          label: {
            backgroundColor: '#6a7985'
          }
        },
        confine: true
      }
    },
    axisPointer: {
      default: {}
    },
    axisLabelRotate: {
      default: 0
    },
    showDetail: {
      type: Boolean,
      default: false
    },
    interval: {
      default: 'auto'
    },
    formatter: {}
  },
  setup: function setup(__props) {
    var props = __props;
    var options = computed(function () {
      var option = {
        tooltip: props.tooltip,
        legend: {
          // left: 80,
          // top: 40,
          // bottom: 10,
          // right: 40
        },
        grid: props.grid,
        xAxis: [{
          type: props.type,
          boundaryGap: false,
          data: props.xLabels,
          axisLabel: {
            rotate: props.axisLabelRotate,
            interval: props.interval
          },
          axisPointer: props.axisPointer
        }],
        yAxis: [{
          type: 'value',
          name: props.yName
        }],
        series: [{
          name: props.legendData[0],
          type: 'line',
          // stack: '总量',
          // areaStyle: {},
          emphasis: {
            focus: 'series'
          },
          smooth: true,
          data: props.lineData
        }]
      };
      if (props.showDetail) {
        option.tooltip.enterable = true;
        option.tooltip.formatter = props.formatter;
      }
      return option;
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(BaseEchart), {
        options: _unref(options),
        height: _ctx.height
      }, null, 8, ["options", "height"])]);
    };
  }
});